// @owners { team: patients-team }
import {
  ActionSheetContext,
  ActionSheetV2,
  Column,
  H2,
  Icon,
  Illustration,
  MdPadding,
  Row,
  SmSpacing,
  XlSpacing,
} from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React, { useContext, useEffect } from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { useDispatchShared } from '~shared/store';

export const VerifiedDetailsActionSheet = ({ nextUrl }: { nextUrl: string }) => {
  const { navigate } = useNavigation();
  const dispatch = useDispatchShared();
  const { closeActionSheet } = useContext(ActionSheetContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(nextUrl);
      closeActionSheet();
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [closeActionSheet, nextUrl, dispatch, navigate]);

  return (
    <ActionSheetV2 analyticsName="onboarding_verified_details">
      <MdPadding>
        <Column
          gap="XL"
          center
          flexGrow={1}
          flexShrink={1}
        >
          <Row
            center
            gap="MD"
          >
            <Icon
              name="checkmark"
              accessibilityLabel={IMG_ALT_TEXTS.greenCheckmark}
            />
            <SmSpacing />
            <H2 center>Success!</H2>
          </Row>
          <Illustration
            size="xl"
            source={getImage('gear')}
            accessibilityLabel="Illustration of two gears spinning"
          />
          <H2 center>Let's set up your account in just a few steps...</H2>
        </Column>
        <XlSpacing />
      </MdPadding>
    </ActionSheetV2>
  );
};
